// Confirmation dans la page, à la place de window.confirm : la fenêtre du navigateur fige
// l'onglet que pilote Claude in Chrome (il ne peut ni la lire ni y répondre). Même usage :
// `if (!(await confirmer(texte))) return`. Les demandes passent une à une, dans l'ordre ; la
// fenêtre est rendue par `HoteConfirmation`, monté à la racine de l'appli. Sans lui (rendu
// hors de l'appli), la fenêtre du navigateur reprend.

export type DemandeConfirmation = { id: number; texte: string }

type Attente = DemandeConfirmation & { resoudre: (oui: boolean) => void }

let attentes: Attente[] = []
let enTete: readonly DemandeConfirmation[] = []
let suivant = 0
const abonnes = new Set<() => void>()

function publier() {
  enTete = attentes.map(({ id, texte }) => ({ id, texte }))
  for (const f of abonnes) f()
}

/** Vrai si la personne confirme, faux si elle annule (bouton, Échap ou clic hors de la fenêtre). */
export function confirmer(texte: string): Promise<boolean> {
  if (!abonnes.size)
    // eslint-disable-next-line no-restricted-properties -- dernier recours, hors de l'appli
    return Promise.resolve(typeof window !== 'undefined' && window.confirm(texte))
  return new Promise((resoudre) => {
    attentes = [...attentes, { id: ++suivant, texte, resoudre }]
    publier()
  })
}

/** Réponse à une demande ; une demande déjà répondue est ignorée. */
export function repondre(id: number, oui: boolean) {
  const a = attentes.find((x) => x.id === id)
  if (!a) return
  attentes = attentes.filter((x) => x.id !== id)
  publier()
  a.resoudre(oui)
}

/** Les demandes en attente, la première affichée (même tableau tant que rien ne change). */
export const demandesConfirmation = () => enTete

export function abonnerConfirmation(f: () => void) {
  abonnes.add(f)
  return () => {
    abonnes.delete(f)
  }
}
